import { createElement } from 'react';
import { BackstagePlugin, getComponentData } from '@backstage/core-plugin-api';
import { EntityChangelogCard } from '@rsc-labs/backstage-changelog-plugin';

export { shortcutsPlugin } from '@backstage-community/plugin-shortcuts';
// The component page of rtl-data renders the GitLab and the changelog cards,
// and the app finds no plugin inside a page of another plugin: their api
// factories only reach the app from here. Without them the tabs throw
// `No implementation available for apiRef{plugin.gitlabci.service}` and
// `...{plugin.changelog.client}`.
export { gitlabPlugin } from '@immobiliarelabs/backstage-plugin-gitlab';
// The changelog package exports its components only, not its plugin. A
// component a plugin provides carries the plugin as `core.plugin`.
export const changelogPlugin = getComponentData<BackstagePlugin>(
    createElement(EntityChangelogCard),
    'core.plugin',
)!;
// The DevTools page renders `UnprocessedEntitiesContent` rather than the
// plugin's own routable page, and the api factory of a legacy plugin only
// reaches the app through the plugin itself - without this the tab throws
// `No implementation available for apiRef{plugin.catalog-unprocessed-entities.service}`.
export { catalogUnprocessedEntitiesPlugin } from '@backstage/plugin-catalog-unprocessed-entities';
// The ADRs tab is `AdrContent` of rtl-data, which uses the plugin's api and
// reader but none of its extensions, so nothing in the element tree brings
// the plugin in: its `adrApiRef` factory has to come from here. Without it
// the tab throws `No implementation available for apiRef{plugin.adr.api}`.
export { adrPlugin } from '@backstage-community/plugin-adr';
// Deliberately NOT exporting `techdocsEditorPlugin` here. Its
// `TechDocsEditorApiRef` factory already reaches the app through the
// `/techdocs-editor/:namespace/:kind/:name` route in `App.tsx`, which
// `convertLegacyAppRoot` converts under the plugin's own id. Exporting the
// plugin here as well makes `convertLegacyAppOptions` offer the same api a
// second time under the `app` plugin and startup dies with
// `API_FACTORY_CONFLICT: API 'plugin.techdocs-editor.api' is already provided`.
